import { quickVaultCreditCardPaymentButton } from "@petsure/core";

/**
 * The input bindings for the AngularJS credit card button component.
 */
export interface QuickVaultCreditCardPaymentButtonBindings {
  quickWebTokenHandlerEndpoint:string;
  formUrl: string;
  communityCode: string;
  customerReferenceNumber: string;
  returnUrl: string;
  cancelUrl: string;
  supplierBusinessCode: string;
  partner: string;
  requestHeaders: HeadersInit | string;
  mapResponseType: string;
  buttonClasses?: string;
  buttonText?: string;
  onBeforePaymentSubmit?: Function;
}

/**
 * AngularJS controller type
 */
export interface QuickVaultCreditCardPaymentButtonController
  extends ng.IController, QuickVaultCreditCardPaymentButtonBindings {
  onClick: () => void;
}

/**
 * AngularJS component definition
 */
export const QuickVaultCreditCardPaymentButtonComponent: ng.IComponentOptions = {
  bindings: {
    quickWebTokenHandlerEndpoint: '@',
    formUrl: '@',
    communityCode: '@',
    encryptedUserState: '@',
    customerReferenceNumber: '@',
    buttonText: '@?',
    buttonClasses: '@?',
    returnUrl: '@',
    cancelUrl: '@',
    supplierBusinessCode: '@',
    partner: '@',
    requestHeaders: '@',
    mapResponseType: '@',
    prePaymentCallback: '@',
    onBeforePaymentSubmit: '&?'
  },

  controller: function (
    this: QuickVaultCreditCardPaymentButtonController
  ) {
    this.$onInit = () => {
      if (!this.buttonText) {
        this.buttonText = "Pay with Credit Card";
      }
      if (!this.buttonClasses) {
        this.buttonClasses = ""
      }
    };

    this.onClick = () => {
      quickVaultCreditCardPaymentButton({
        quickWebTokenHandlerEndpoint: this.quickWebTokenHandlerEndpoint,
        formUrl: this.formUrl,
        communityCode: this.communityCode,
        customerReferenceNumber: this.customerReferenceNumber,
        returnUrl: this.returnUrl,
        cancelUrl: this.cancelUrl,
        supplierBusinessCode: this.supplierBusinessCode,
        partner: this.partner,
        requestHeaders: this.requestHeaders,
        mapResponseType: this.mapResponseType,
        onBeforePaymentSubmit: this.onBeforePaymentSubmit,
      });
    };
  },

  template: `
    <button class="ps-quick-vault-credit-card-payment-button {{$ctrl.buttonClasses}}"
            ng-click="$ctrl.onClick()">
      {{$ctrl.buttonText}}
    </button>
  `
};